import axios from "axios";

const ingrooveApi = axios.create({
  baseURL: 'https://api.ingroove.co.za/api',// process.env.REACT_APP_INGROOVE_API_URL,
  headers: { "Content-Type": "application/json" },
});

ingrooveApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("omnyx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

ingrooveApi.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("omnyx_token");
      localStorage.removeItem("omnyx_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default ingrooveApi;
